<template>
  <div class="settings-notifications">
    <div class="notifications ma-2">
      <notifications />
    </div>
  </div>
</template>

<script>
import Notifications from '@/components/settings/notifications'

export default {
  name: 'settings-notifications',
  components: {
    Notifications
  }
}
</script>

<style></style>
